export type Shape = 'landscape' | 'portrait' | 'square';

/** Near-square photos (within ~15%) suit either orientation. */
export function shapeOf(width: number | null | undefined, height: number | null | undefined): Shape | null {
  if (!width || !height) return null;
  const ratio = width / height;
  if (ratio > 1.15) return 'landscape';
  if (ratio < 1 / 1.15) return 'portrait';
  return 'square';
}

/** Does a photo of this size suit a screen of this orientation? Unknown sizes count as a match. */
export function fitsScreen(width: number | null | undefined, height: number | null | undefined, screen: 'landscape' | 'portrait'): boolean {
  const shape = shapeOf(width, height);
  return shape === null || shape === 'square' || shape === screen;
}
